export function read(file, onProgress) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.addEventListener('load', event => {
            resolve(event.target.result)
        })

        reader.addEventListener('error', () => {
            reject(new Error('Error reading file: ' + file.name))
        })

        if (typeof onProgress === 'function') {
            reader.addEventListener('progress', event => {
                onProgress(event.loaded)
            })
            reader.addEventListener('loadstart', () => {
                onProgress(0)
            })
            reader.addEventListener('loadend', () => {
                onProgress(file.size)
            })
        }

        reader.readAsDataURL(file)
    })
}
